import React, { useState } from 'react';
import { EmployerLayout } from '../JobPostPricing/EmployerLayout';
import SavedList from './SavedList';
import { useNavigate } from 'react-router-dom';
import { Inline } from '@/Components/ui/layout';
import { Button } from '@/Components/ui/button';
import { Label } from '@/Components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/Components/ui/select';

export const SavedCandidate = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState('');

  const handleFilterChange = (value) => {
    setFilter(value);
  };

  return (
    <EmployerLayout>
      <div className="flex flex-col w-full gap-8">
        <Inline justify="end" className="w-full">
          <Button
            variant="outline"
            onClick={() => navigate('/hirewithus/postjob')}
            className="flex items-center gap-2 bg-[#f3f3f4] rounded-xl px-5 py-2.5"
          >
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/8103bbcb4fc48d177a4ce47b728aab0ddb2decffe421fc6e64e0e4238d1ecc00?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
              alt="Icon"
              className="w-[34px] h-[30px]"
            />
            <span className="text-foreground font-semibold text-base px-2.5 py-2.5 border-2 border-[#79a7d5] rounded-[10px]">
              Post Job
            </span>
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/7c7da7787896c57a951c679a02375bd00309c34b84ec629d2a50c9a0c27b5e52?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
              alt="Profile Icon"
              className="w-[34px] h-[30px] ml-2"
            />
          </Button>
        </Inline>
        <div className="flex flex-col gap-10 w-full">
          <Inline justify="end" align="center" className="mb-15 -mt-[8%] ml-[60%]">
            <Label htmlFor="job-title-filter" className="text-base font-bold text-foreground mr-2.5">
              Filter by Job Title:
            </Label>
            <Select value={filter} onValueChange={handleFilterChange}>
              <SelectTrigger id="job-title-filter" className="w-[200px] px-3 py-2 text-base border border-border rounded-md bg-white text-foreground">
                <SelectValue placeholder="All" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="">All</SelectItem>
                <SelectItem value="Software Engineer">Software Engineer</SelectItem>
                <SelectItem value="Data Scientist">Data Scientist</SelectItem>
                <SelectItem value="Product Manager">Product Manager</SelectItem>
                <SelectItem value="UX Designer">UX Designer</SelectItem>
              </SelectContent>
            </Select>
          </Inline>
          <SavedList filter={filter} />
        </div>
      </div>
    </EmployerLayout>
  );
};
